<template>
  <main :class="$style['main-container']">
    <section :class="$style['img-container']">
      <img src="/images/logo.png" alt="Dashboard image" />
    </section>

    <section :class="$style['login-container']">
      <aside :class="$style['login-box']">
        <h1>Ingreso al Panel de Administración</h1>

        <div
          style="
            background: #4f4ffb;
            height: 2px;
            width: 100%;
            margin-bottom: 17px;
          "
        ></div>

        <p style="margin-top: 10px;">
          Redirigiendo al proveedor de autenticación...
        </p>

        <div
          v-if="errorMessage"
          style="
            padding: 5px 10px;
            white-space: nowrap;
            font-size: 13px;
            font-weight: 600;
            text-align: center;
          "
          class="alert alert-danger mt-4 rounded-pill"
        >
          {{ errorMessage }}
        </div>
      </aside>
    </section>
  </main>
</template>

<script>
import instance from "@/plugins/axios";
import keycloak, { login as keycloakLogin } from "@/services/api/keycloak";

export default {
  data() {
    return {
      errorMessage: "",
    };
  },

  async beforeMount() {
    document.title = `Dashboard | Login`;

    try {
      // 1) Si ya está autenticado en Keycloak, no mostramos nada de login local
      if (keycloak.authenticated) {
        // OPCIONAL: acá podés ir a buscar los datos del usuario al backend
        await this.fetchUserFromBackend();
        this.$router.replace("/main");
        return;
      }

      // 2) Si NO está autenticado, mandamos a Keycloak
      await keycloakLogin({
        // Usamos /login como callback de retorno
        redirectUri: window.location.origin + "/login",
      });
    } catch (error) {
      console.error("Error en flujo de login con Keycloak:", error);
      this.errorMessage =
        "No se pudo iniciar sesión con el proveedor de autenticación.";
    }
  },

  methods: {
    async fetchUserFromBackend() {
      try {
        // Suponiendo que tu backend ahora tiene un endpoint que
        // devuelve los datos del usuario autenticado por el token de Keycloak.
        // Adaptá la URL/método si lo cambiaste (GET/POST /login o /me, etc).
        const res = await instance.get("login");

        if (res && res.data && res.data.data) {
          const user = res.data.data;
          window.localStorage.setItem("user_name", user.name);
          // Si querés guardar más datos, hacelo acá
        }
      } catch (e) {
        console.error("Error obteniendo datos de usuario desde backend:", e);
        // No detiene el login, solo registra el error
      }
    },
  },
};
</script>

<style module>
.main-container {
  display: flex;
  justify-content: center;
  height: 100vh;
}

.img-container {
  display: none;
  justify-content: center;
  align-items: center;
  background-color: #e7f3fe;
  width: 50%;
}

.img-container img {
  width: 400px;
  height: auto;
}

/* --------------------------------------------------- */

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.login-box {
  width: 80%;
  max-width: 450px;
}

.login-box h1 {
  font-size: 20px;
  font-weight: 700;
}

@media screen and (min-width: 900px) {
  .main-container {
    justify-content: initial;
  }

  .img-container {
    display: flex;
  }

  .login-container {
    width: 50%;
  }

  .login-box {
    width: 60%;
  }
}
</style>
